/* global bocAmchart4 */

/**
 * Get the url parameters for select dropdowns
 * @param {AMConfig} chart Chart Object to be used to build this chart
 * @returns {*[]} values
 */
bocAmchart4.urlParamInteractive = function (chart) {
    //Get query params
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    //Check to see if the chart id (minus 'am') is a url param
    let chartId = chart.bocSettings.id.replace('am', '');
    let chartParams = urlParams.get(chartId);
    //Check to see if params exist for this chart
    let values = [];
    if (chartParams) {
        values = chartParams.split(",");
    }
    return values;
};

/**
 * Dynamically create the interactive section for a chart with given chart settings and config.
 * parse json object to get data
 *
 * @param {AMConfig} chart Chart Object to be used to build this chart
 * @param {object} config Interactive config object
 * @returns {void}
 */
bocAmchart4.createInteractive = function (chart, config) {
    //Get the url param values for which input selection
    let values = bocAmchart4.urlParamInteractive(chart);
    values.forEach(function (value, index) {
        //array offset
        let tempValue = value - 1;
        //We're going to assume for this that there is only one section
        if (config.hasOwnProperty('sections') && config.sections.hasOwnProperty(0)) {
            let section = config.sections[0];
            if (section.hasOwnProperty('parameters') && section.parameters.hasOwnProperty(index)) {
                if (section.parameters[index].hasOwnProperty('options') && section.parameters[index].options.hasOwnProperty(tempValue)) {
                    //eslint-disable-next-line camelcase
                    section.parameters[index].initial_value = section.parameters[index].options[tempValue];
                }
            }
        }
    });

    this.chart = chart;
    this.config = config;
    this.divId = chart.bocSettings.id;
    chart.bocSettings.interactiveConfig = config;
    var chartVar = document.getElementById(chart.bocSettings.id);
    chartVar.style.border = '2px solid transparent';
    chartVar.style.borderRadius = '4px';

    var closeButton = document.createElement('span');
    closeButton.className = 'interactive-close bocss-button--primary';
    closeButton.id = 'close-' + this.divId;
    closeButton.textContent = 'Close';

    var interactiveChart = document.getElementById(this.divId + '-interactive');
    interactiveChart.appendChild(closeButton);


    Object.keys(this.config.sections).forEach(function (key) {
        bocAmchart4.addInteractiveSection(chart.bocSettings.id, config.sections[key], chart, key);
    });


    var buttonText = 'Customize Chart Parameters';
    if (config.buttonText) {
        buttonText = config.buttonText;
    }
    var button = document.createElement('button');
    button.id = this.divId + '-bttn';
    button.className = 'bocss-interactive-button bocss-button bocss-button--primary bocss-button--small';
    button.textContent = buttonText;
    var interactiveElement = document.getElementById(chart.bocSettings.id + '-interactive');
    var $containers = jQuery('.container');

    button.onclick = function () {
        if (bocAmchart4.hasClass(interactiveElement, 'show-menu')) {
            interactiveElement.classList.remove("show-menu");
            chartVar.classList.remove("open");
            $containers.removeClass('shift-containers');
        } else {
            interactiveElement.classList.add("show-menu");
            chartVar.classList.add("open");
            $containers.addClass('shift-containers');
        }
    };

    var body = document.body;

    body.addEventListener("click", function (ev) {
        if (bocAmchart4.hasClass(interactiveElement, 'show-menu') && ev.target.id !== chart.bocSettings.id + '-bttn') {
            interactiveElement.classList.remove("show-menu");
            chartVar.classList.remove("open");
            $containers.removeClass('shift-containers');
        }
    }, false);

    interactiveElement.addEventListener("click", function (ev) {
        if (ev.target.id !== 'close-' + chart.bocSettings.id) {
            //this is important! If removed, you'll get both alerts
            ev.stopPropagation();
        }
    }, false);

    bocAmchart4.insertAfter(button, interactiveChart);
};

/**
 * Checks if class is present on element
 * @param {HTMLElement} element in question
 * @param {string} className to check
 * @returns {boolean} has class?
 */
bocAmchart4.hasClass = function (element, className) {
    if (element.classList) {
        return element.classList.contains(className);
    }
    return !!element.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
};

/**
 * Inserts element after another element
 * @param {HTMLElement} newNode to add
 * @param {HTMLElement} referenceNode after which to add it
 * @returns {void}
 */
bocAmchart4.insertAfter = function (newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
};

/**
 * Create interactive section
 * @param {string} id chart id
 * @param {object} section Json section config
 * @param {AMConfig} chart Chart Object
 * @param {string} key number as string
 * @returns {void}
 */
bocAmchart4.addInteractiveSection = function (id, section, chart, key) {
    var parent = section.title.replace(/\s+/g, '-').toLowerCase();
    var sectionId = section.title.replace(/\s+/g, '-').toLowerCase();

    var div = document.createElement("div");
    div.id = sectionId;
    div.className = section.title.replace(/\s+/g, '-').toLowerCase();
    var tooltip = section.description ? '<div class="tooltip" title="' + section.description + '">&#128712;</div>' : '';
    var colorDiv = section.color ? '<div id="' + sectionId + '-color" class="interactive-color"><div class="interactive-square" style="background-color: ' + section.color + '"></div></div>' : '';
    div.innerHTML = section.description ? '<div class="section-header">' + colorDiv + '<h3>' + section.title + tooltip + '</h3></div> ' : '<div class="section-header">' + colorDiv + '<h3>' + section.title + '</h3></div> ';
    if (key === "0") {
        div.style = "margin-top:58px;";
    }
    document.getElementById(id + '-interactive').appendChild(div);

    let selectCount = 0;

    Object.keys(section.parameters).forEach(function (key) {
        var parameters = section.parameters[key];
        if (parameters.type === 'select') {
            selectCount++;
        }
        bocAmchart4.addInteractiveParameters(parent, parameters, chart);
    });

    if (section.hasOwnProperty('maxDropdowns') && section.maxDropdowns > 0 && section.maxDropdowns < 5) {
        document.getElementById(id + '-interactive').classList.add('interactive-dropdowns-' + section.maxDropdowns);
    } else if (selectCount === 2) {
        document.getElementById(id + '-interactive').classList.add('interactive-dropdowns-2');
    } else if (selectCount === 1) {
        document.getElementById(id + '-interactive').classList.add('interactive-dropdowns-1');
    }
};

/**
 *
 * @param {HTMLDivElement} parent element
 * @param {object} parameters object
 * @param {AMConfig} chart Chart Object
 * @returns {HTMLDivElement} parameter div element
 */
bocAmchart4.addInteractiveParameters = function (parent, parameters, chart) {
    var parameterDiv = document.createElement("div");
    var inputTag;
    var classType = 'input';
    if (parameters.type === 'checkbox') {
        classType = 'checkbox';
    } else if (parameters.type === 'date') {
        classType = 'input interactive-date';
    } else if (parameters.type === 'select') {
        classType = 'input interactive-select bocss-select__group';
    }
    parameterDiv.className = 'interactive-' + classType;

    document.getElementById(parent).appendChild(parameterDiv);

    var labelTag = document.createElement("label");
    labelTag.innerHTML = parameters.label;
    labelTag.innerHTML += parameters.dimension ? ' (' + parameters.dimension + ')' : '';
    labelTag.htmlFor = parameters.id;

    parameterDiv.appendChild(labelTag);
    var option;
    if (parameters.type === 'date') {
        inputTag = document.createElement("select");
        inputTag.id = parameters.id;
        inputTag.className = 'bocss-select';

        parameters.sr_label ? inputTag.setAttribute('aria-label', parameters.sr_label) : '';
        for (var year = parameters.options.startYear; year <= parameters.options.endYear; year++) {
            option = document.createElement("option");
            option.value = year;
            option.innerHTML = year;
            inputTag.appendChild(option);
        }

        if (parameters.dimension === 'Q' || parameters.dimension === 'quarter') {
            var selectDiv = document.createElement('div');
            selectDiv.className = 'bocss-select__group';

            var dimensionInput = document.createElement("select");
            dimensionInput.className = 'bocss-select';
            dimensionInput.id = parameters.id + '-quarter';
            for (var quarterNum = 1; quarterNum <= 4; quarterNum++) {
                var dimensionOption = document.createElement("option");
                dimensionOption.value = 'Q' + quarterNum;
                dimensionOption.innerHTML = 'Q' + quarterNum;
                dimensionInput.appendChild(dimensionOption);
            }
            selectDiv.appendChild(dimensionInput);

            var arrowQ = document.createElement("i");
            arrowQ.className = "arrow downward";
            selectDiv.appendChild(arrowQ);

            parameterDiv.appendChild(selectDiv);

            var selectDiv2 = document.createElement('div');
            selectDiv2.className = 'bocss-select__group';

            selectDiv2.appendChild(inputTag);
            var arrow = document.createElement("i");
            arrow.className = "arrow downward";
            selectDiv2.appendChild(arrow);
            parameterDiv.appendChild(selectDiv2);
        }
    } else if (parameters.type === 'select') {
        inputTag = document.createElement("select");
        inputTag.id = parameters.id;

        inputTag.className = 'bocss-select';

        parameters.sr_label ? inputTag.setAttribute('aria-label', parameters.sr_label) : '';
        if (Array.isArray(parameters.options)) {
            // No option values are given
            parameters.currentValue = parameters.initial_value ? parameters.initial_value : parameters.options[0];
            for (var parameter = 0; parameter < parameters.options.length; parameter++) {
                option = document.createElement("option");
                option.value = parameters.options[parameter];
                option.innerHTML = parameters.options[parameter];
                option.selected = parameters.options[parameter] == parameters.initial_value;
                inputTag.appendChild(option);
            }
        } else {
            // Option values are given
            parameters.currentValue = parameters.initial_value ? parameters.options[parameters.initial_value] : Object.values(parameters.options)[0];
            for (var index in parameters.options) {
                option = document.createElement("option");
                option.value = parameters.options[index];
                option.innerHTML = index;
                option.selected = index == parameters.initial_value;
                inputTag.appendChild(option);
            }
        }

        inputTag.onchange = function () {
            parameters.currentValue = inputTag.value;
            chart.bocSettings.interactiveProcessor.updateParametersInteractive(true, true);
        };
    } else {
        inputTag = document.createElement("input");
        inputTag.setAttribute("type", parameters.type);
        inputTag.id = parameters.id;
        parameters.sr_label ? inputTag.setAttribute('aria-label', parameters.sr_label) : '';
        if (parameters.type === 'checkbox') {
            inputTag.checked = parameters.checked ? parameters.checked : '';
            inputTag.onchange = function () {
                parameters.currentValue = inputTag.checked;
                chart.bocSettings.interactiveProcessor.updateParametersInteractive(true, true);
            };
        } else if (parameters.type === 'number') {
            inputTag.className = 'bocss-input__text';
            inputTag.min = parameters.min ? parameters.min : '';
            inputTag.max = parameters.max ? parameters.max : '';
            inputTag.step = parameters.step ? parameters.step : '';
            inputTag.defaultValue = parameters.initial_value ? parameters.initial_value : 0;
            var regex = new RegExp('[0-9]|\\.');

            inputTag.onkeypress = function (event) {
                if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                    return true;
                }
                if (!regex.test(event.key)) {
                    return false;
                }
            };

            inputTag.onchange = function () {
                parameters.currentValue = inputTag.value;
                chart.bocSettings.interactiveProcessor.updateParametersInteractive(true, true);
            };
        }
    }


    if (parameters.dimension !== 'Q' && parameters.dimension !== 'quarter') {
        parameterDiv.appendChild(inputTag);
    }

    if (parameters.type === 'select') {
        var arrowSelect = document.createElement("i");
        arrowSelect.className = "arrow downward";
        parameterDiv.appendChild(arrowSelect);
    }
    return parameterDiv;
};
